export const isFunction = variable => ({}.toString.call(variable) === '[object Function]');



// WEBPACK FOOTER //
// ./app/javascript/common/utils/core.js